exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-align-wrapper{position:relative}.v-align-wrapper .v-align{position:absolute;left:0;right:0;top:50%;transform:translateY(-50%)}.async-anim-controller{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f7ba1e6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AsyncAnimation.vue
// module id = 278
// module chunks = 0